import { useMemo } from "react";
import { UrgentVisitStep } from "../../state/urgent-visit";
import {
  useUrgentVisitStore,
} from "../redux-hooks/urgent-visit-store/urgent-visit.store";

export const useUrgentVisitValidation = () => {
  const {
    currentStep, selectedPets, selectedSlot, petBookingData, currentPetIndex,
  } = useUrgentVisitStore();

  const currentPet = selectedPets[currentPetIndex];

  const isCtaDisabled = useMemo(() => {
    switch (currentStep) {
    case UrgentVisitStep.PET_SELECTION:
      return selectedPets.length === 0;
    case UrgentVisitStep.TIME_SELECTION:
      return !selectedSlot;
    case UrgentVisitStep.REASON_SELECTION: {
      if (!currentPet) return true;
      const petData = petBookingData[currentPet.id];

      return !petData?.selectedReasons?.length;
    }
    case UrgentVisitStep.ADDITIONAL_NOTES:
      return false;
    case UrgentVisitStep.REVIEW:
      return false;
    default:
      return false;
    }
  }, [currentStep, selectedPets, selectedSlot, petBookingData, currentPet]);

  return { isCtaDisabled };
};
